import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, ButtonGroup, DropdownButton, InputGroup} from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown';
import {FaRegTrashAlt} from "react-icons/fa";

class Gain extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.addSetting = this.addSetting.bind(this);
    this.deleteSetting = this.deleteSetting.bind(this);
    this.setSettingGain = this.setSettingGain.bind(this);
    this.setGain = this.setGain.bind(this);
    this.setTime = this.setTime.bind(this);
    this.setToolId = this.setToolId.bind(this);
  }

  addSetting = (event) => {
    const settingName = event.target.text;
    let newSetting = {
      name: settingName
    };
    switch (settingName) {
      case "cancelScheduledValues":
        break;
      case "cancelAndHoldAtTime":
        break;
      case "setTargetAtTime":
        break;
      case "exponentialRampToValueAtTime":
      case "linRampToValueAtTime":
      case "setValueAtTime":
        newSetting.gain = 1;
        newSetting.time = 1;
        break;
      case "setValueCurveAtTime":
        break;
      default:
        console.warn("Unknown setting: " + settingName);
        break;
    }
    this.props.config.settings.push(newSetting);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  deleteSetting = (index) => {
    this.props.config.settings.splice(index, 1);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setGain = (event) => {
    this.props.config.gain = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setSettingGain = (settingName, gain) => {
    this.props.config.settings = this.props.config.settings.map(setting => {
      if(setting.name === settingName){
        setting.gain = parseFloat(gain);
      }
      return setting;
    });
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setTime = (settingName, time) => {
    this.props.config.settings = this.props.config.settings.map(setting => {
      if(setting.name === settingName){
        setting.time = parseFloat(time);
      }
      return setting;
    });
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setToolId = (event) => {
    const newToolId = event.target.value;
    let config = Object.assign({}, this.props.config);
    config.id = newToolId;
    this.props.setToolConfig(this.props.config.id, config);
  }

  render() {
    return (
        <div className={"gain toolChainTool"}>
          <h3>Gain</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <DropdownButton as={ButtonGroup} title="+Setting" id="bg-nested-dropdown">
            <Dropdown.Item onClick={this.addSetting}>cancelScheduledValues</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>cancelAndHoldAtTime</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>exponentialRampToValueAtTime</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>linRampToValueAtTime</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>setTargetAtTime</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>setValueAtTime</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>setValueCurveAtTime</Dropdown.Item>
          </DropdownButton>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>gain</InputGroup.Text>
            <Form.Control type="number" min={.001} max={5} step={.01}
                          value={this.props.config.gain}
                          onChange={this.setGain}/>
          </InputGroup>
          <div className={"toolSettings"}>
            {this.props.config.settings && this.props.config.settings.map((setting, index) => (
                <div className={"toolSetting"} key={index}>
                  <Form.Group>
                    <InputGroup>
                      <Form.Select defaultValue={setting.name} onChange={()=>{console.log("test")}}>
                        <option value={"cancelScheduledValues"}>cancelScheduledValues</option>
                        <option value={"cancelAndHoldAtTime"}>cancelAndHoldAtTime</option>
                        <option value={"exponentialRampToValueAtTime"}>expRampToValueAtTime</option>
                        <option value={"linRampToValueAtTime"}>linRampToValueAtTime</option>
                        <option value={"setTargetAtTime"}>setTargetAtTime</option>
                        <option value={"setValueAtTime"}>setValueAtTime</option>
                        <option value={"setValueCurveAtTime"}>setValueCurveAtTime</option>
                      </Form.Select>
                      <Button variant={"secondary"} onClick={()=>{this.deleteSetting(index)}}>x</Button>
                    </InputGroup>
                    <Form.Range min={.001} max={1} step={.01}
                                value={setting.gain}
                                onChange={(event) => this.setSettingGain(setting.name, event.target.value)}/>
                    <Form.Range min={.001} max={5} step={.1}
                                value={setting.time}
                                onChange={(event) => this.setTime(setting.name, event.target.value)}/>
                  </Form.Group>
                </div>
            ))}
          </div>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default Gain;